import React, { useEffect, useState } from 'react';
import CancellationsApi from '../../../api/CancellationsApi';
import { AuthData } from '../../../context/auth';
import {
	CancellationData,
	withCancellationContext,
} from '../../../context/CancellationProvider';
import { PolicyDocument } from '../../../types/policy';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../../common';
import DocumentsTable from '../../DocumentsTable';

interface Props {
	cancellationData: CancellationData;
	documents: PolicyDocument[];
	isReinstatement?: boolean; // passed from ReinstatementRoutes
	authData: AuthData;
}

const DocumentsView = (props: Props) => {
	const {
		documents,
		authData: { auth },
		isReinstatement,
		cancellationData: { selectedCancellation },
	} = props;

	const [latestDocs, setDocuments] = useState(documents);

	useEffect(() => {
		let timer: any = 0;
		const fetchCancellation = async () => {
			try {
				const updatedCancellation = await CancellationsApi.getCancellation(
					auth.authorizationToken,
					selectedCancellation.locator,
				);
				const updatedDocs = isReinstatement
					? updatedCancellation.data.reinstatement.documents
					: updatedCancellation.data.documents;
				setDocuments(updatedDocs);
				if (updatedDocs && !updatedDocs.every((d) => !!d.url)) {
					timer = setTimeout(() => {
						fetchCancellation();
					}, 30000);
				}
			} catch (err) {
				console.error(err);
			}
		};
		// if not all docs have url, fetch cancellation again
		if (documents && !documents.every((d) => !!d.url)) {
			fetchCancellation();
		}
		return () => clearTimeout(timer);
	}, []);

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Documents</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<DocumentsTable documents={latestDocs} />
			</StyledSectionContainer>
		</>
	);
};

export default withCancellationContext<Props>(DocumentsView);
